module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [(_vm.localResetPasswordSuccessMessage) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.localResetPasswordSuccessMessage))])])]) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), (!_vm.loggedIn && !_vm.$route.query.admin) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('b', [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        Uppgifterna stämde inte. Försök igen med ett annat lösenord eller beställ ett nytt lösenord nedan.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "spacer"
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? 'Loggar in...' : 'Logga in'))])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "spacer"
  }, [_vm._v(" ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button white small underlined",
    attrs: {
      "to": {
        name: 'request reset password'
      }
    }
  }, [_vm._v("Glömt lösenord")]), _vm._v(" "), _c('router-link', {
    staticClass: "button white small underlined",
    attrs: {
      "to": {
        name: 'request new password'
      }
    }
  }, [_vm._v("Har inget lösenord")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.admin && !_vm.adminUser) ? _c('div', {
    staticClass: "flex"
  }, [(_vm.microsoftSsoEnabled) ? _c('div', {
    staticClass: "center ms-login-container"
  }, [_c('h3', [_vm._v("Administrationsinloggning")]), _vm._v(" "), _c('p', {
    staticClass: "ms-info-text"
  }, [_vm._v("Logga in säkert med ditt Microsoft-konto.")]), _vm._v(" "), (_vm.ssoError) ? _c('div', {
    staticClass: "error-box"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.getErrorMessage(_vm.ssoError)))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ms-btn",
    on: {
      "click": function($event) {
        return _vm.loginWithMicrosoft()
      }
    }
  }, [_c('span', {
    staticClass: "ms-icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 23 23",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#f35325",
      "d": "M0 0h11v11H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#81bc06",
      "d": "M12 0h11v11H12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#05a6f0",
      "d": "M0 12h11v11H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffba08",
      "d": "M12 12h11v11H12z"
    }
  })])]), _vm._v("\n        Logga in med Microsoft\n      ")])]) : _c('div', [(_vm.successMessage) ? _c('div', {
    staticClass: "success-box"
  }, [_c('p', {
    staticClass: "success-message"
  }, [_vm._v(_vm._s(_vm.successMessage))])]) : _c('div', [_c('div', [_c('b', [_vm._v("E-postadress för admin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMagicLink($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0",
      "max-width": "260px"
    }
  }, [_c('altcha-widget', {
    attrs: {
      "challengeurl": _vm.altchaUrl,
      "hideLogo": ""
    },
    on: {
      "statechange": _vm.onAltchaChange
    }
  })], 1), _vm._v(" "), (_vm.error) ? _c('div', [_c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage || 'Uppgifterna stämde inte. Försök igen.'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('p', {
    staticClass: "spacer"
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.loading || !_vm.altchaVerified
    },
    on: {
      "click": function($event) {
        return _vm.sendMagicLink()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loading ? 'Skickar...' : 'Skicka inloggningslänk') + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.adminUser || _vm.$route.query.admin) ? _c('div', [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.adminUser) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToAdmin()
      }
    }
  }, [_vm._v("Gå till admin")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Du är inloggad i admin")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small white",
    on: {
      "click": function($event) {
        return _vm.logoutAdmin()
      }
    }
  }, [_vm._v("Logga ut från admin")])])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('p', [_vm._v("Du är inloggad")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logga ut")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cabfd66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Login.vue
// module id = 912
// module chunks = 0